<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2727 3.25C11.8585 3.25 11.5227 3.58579 11.5227 4C11.5227 4.41421 11.8585 4.75 12.2727 4.75V3.25ZM12.2727 19.25C11.8585 19.25 11.5227 19.5858 11.5227 20C11.5227 20.4142 11.8585 20.75 12.2727 20.75V19.25ZM5 12L4.46967 11.4697C4.17678 11.7626 4.17678 12.2374 4.46967 12.5303L5 12ZM6.65149 14.7121C6.94438 15.005 7.41926 15.005 7.71215 14.7121C8.00504 14.4193 8.00504 13.9444 7.71215 13.6515L6.65149 14.7121ZM7.71215 10.3485C8.00504 10.0556 8.00504 9.58074 7.71215 9.28785C7.41926 8.99495 6.94438 8.99495 6.65149 9.28785L7.71215 10.3485ZM14.4545 12.75C14.8688 12.75 15.2045 12.4142 15.2045 12C15.2045 11.5858 14.8688 11.25 14.4545 11.25V12.75ZM18.8409 17.8182V6.18182H17.3409V17.8182H18.8409ZM15.9091 3.25H12.2727V4.75H15.9091V3.25ZM12.2727 20.75H15.9091V19.25H12.2727V20.75ZM18.8409 6.18182C18.8409 4.56262 17.5283 3.25 15.9091 3.25V4.75C16.6999 4.75 17.3409 5.39105 17.3409 6.18182H18.8409ZM17.3409 17.8182C17.3409 18.609 16.6999 19.25 15.9091 19.25V20.75C17.5283 20.75 18.8409 19.4374 18.8409 17.8182H17.3409ZM4.46967 12.5303L6.65149 14.7121L7.71215 13.6515L5.53033 11.4697L4.46967 12.5303ZM5.53033 12.5303L7.71215 10.3485L6.65149 9.28785L4.46967 11.4697L5.53033 12.5303ZM14.4545 11.25H5V12.75H14.4545V11.25Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconExit'
}
</script>
